import CandidateFilterComponent, {
  CandidateFilterBoxTextProps,
} from './CandidateFilterBoxText.component';

const CandidateFilter = (props: CandidateFilterBoxTextProps): JSX.Element => {
  return <CandidateFilterComponent {...props} />;
};

export default CandidateFilter;
